"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeRegion = void 0;
var TypeRegion;

(function (TypeRegion) {
  /**
   * 지역 설정을 변경해요
   * @required regionId  변경할 지역 ID
   */
  TypeRegion["ReqRegionChange"] = "REQ.REGION.CHANGE";
})(TypeRegion = exports.TypeRegion || (exports.TypeRegion = {}));